import React, { useState, forwardRef, useCallback, useEffect } from 'react';

import Box from '@mui/joy/Box';
import Card from '@mui/joy/Card';
import CardContent from '@mui/joy/CardContent';
import Typography from '@mui/joy/Typography';
import { styled } from '@mui/system';


//////////////// Alert
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';


///////////////// Use Form
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';




///////////////////mune DropDown
import IconButton from '@mui/joy/IconButton';
import Menu from '@mui/joy/Menu';
import MenuItem from '@mui/joy/MenuItem';
import ListItemDecorator from '@mui/joy/ListItemDecorator';
import ListDivider from '@mui/joy/ListDivider';
import MoreVert from '@mui/icons-material/MoreVert';
import Edit from '@mui/icons-material/Edit';
import DeleteForever from '@mui/icons-material/DeleteForever';
import MenuButton from '@mui/joy/MenuButton';
import Dropdown from '@mui/joy/Dropdown';
import { Button } from '@mui/joy';
import Switch, { switchClasses } from '@mui/joy/Switch';
import Autocomplete from '@mui/joy/Autocomplete';

import IconPlus from '../../assets/icons/Plus.svg'
import TrashIcon from '../../assets/icons/trashIcon.svg'
import EditIcon from '../../assets/icons/edit.svg'


///////////////////// Modal
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import Input from '@mui/joy/Input';
import Modal from '@mui/joy/Modal';
import ModalDialog from '@mui/joy/ModalDialog';
import DialogTitle from '@mui/joy/DialogTitle';
import Textarea from '@mui/joy/Textarea';
import Stack from '@mui/joy/Stack';


//////////////////// API
import { createNewSubscrib, getAllSubscrib, deleteSubscrib, getDetailsSubscrib, updateSubscrib } from '../../Api/Subscription';


const schema = yup.object({
    title_ar: yup.string().required("هذا الحقل مطلوب"),
    title_en: yup.string().required("هذا الحقل مطلوب"),
    details_ar: yup.string().required("هذا الحقل مطلوب"),
    details_en: yup.string().required("هذا الحقل مطلوب"),
    orders: yup.string().required("هذا الحقل مطلوب"),
    price: yup.string().required("هذا الحقل مطلوب"),

})


const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function ListOffers() {
    const [subscrib, setSubscrib] = useState([]);
    const [subscribId, setSubscribId] = useState(null);
    const [actionType, setActionType] = useState(null);

    const [openModalConfirmDelete, setOpenModalConfirmDelete] = useState(false);
    const [loadingApi, setLoadingApi] = useState(false)
    const [checked, setChecked] = useState(false);
    const [open, setOpen] = useState(false);
    const [openAlert, setOpenAlert] = useState(false);
    const [messageAlert, setMessageAlert] = useState('');

    const [openAlertError, setOpenAlertError] = useState(false);
    const [messageAlertError, setMessageAlertError] = useState('');

    const form = useForm({
        defaultValues: {
            title_ar: null,
            title_en: null,
            details_ar: null,
            details_en: null,
            orders: null,
            price: null
        },
        resolver: yupResolver(schema)
    });
    const { register, handleSubmit, formState, setValue } = form;
    const { errors } = formState



    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false);
    };

    const handleCloseAlertError = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlertError(false);
    };

    const confirmDelete = (id) => {
        setOpenModalConfirmDelete(true)
        setSubscribId(id)
    }

    const removeٍSubscrib = async () => {
        try{
            setLoadingApi(true)
            const res = await deleteSubscrib(subscribId);
            if(!res){
                return
            }
            getDataSubscrib()
            setMessageAlert('تم حذف الباقة بنجاح')
            setLoadingApi(false)
            setOpenAlert(true)
            setOpenModalConfirmDelete(false)
            setSubscribId(null)
        }catch (error) {
            if (error.response) {
                setOpenModalConfirmDelete(false)
                setSubscribId(null)
                setLoadingApi(false)
                setOpenAlertError(true)
                setMessageAlertError(error.response.data.message)
            }
        }

    }


    const getDataSubscrib = useCallback(async () => {
            const res = await getAllSubscrib()
            if(res){
                setSubscrib(res)
        }
    },[])


    const openEdit = async (id) => {
        try{
            const res = await getDetailsSubscrib(id)
            if(!res){
                return
            }
            setActionType('edit')
            setSubscribId(id)
            setOpen(true)
            setValue('title_ar', res.title_ar)
            setValue('title_en', res.title_en)
            setValue('details_ar', res.details_ar)
            setValue('details_en', res.details_en)
            setValue('orders', res.orders)
            setValue('price', res.price)
        }catch (error) {
            setOpenAlertError(true)
            setMessageAlertError(error.response.data.message)
        }
    }

    const openCreateModel = () => {
        setValue('details_ar', null)
        setValue('details_en', null)
        setValue('orders', null)
        setValue('price', null)
        setValue('title_ar', null)
        setValue('title_en', null)
        setActionType(null)
        setOpen(true)
    }


    const submitSubscrib = async (data) => {
        try {
            setLoadingApi(true)
            if(actionType == 'edit') {
                const res = await updateSubscrib(subscribId, data)
                if (!res) {
                    return
                }
                getDataSubscrib()
                setLoadingApi(false)
                setOpen(false)
                setValue('title_ar', null)
                setValue('title_en', null)
                setValue('details_ar', null)
                setValue('details_en', null)
                setValue('orders', null)
                setValue('price', null)
                setActionType(null)
                setMessageAlert('تم تعديل الباقة بنجاح')
                setOpenAlert(true)
    
            }else{
                const res = await createNewSubscrib(data)
                if (!res) {
                    return
                }
                getDataSubscrib()
                setLoadingApi(false)
                setOpen(false)
                setValue('title_ar', null)
                setValue('title_en', null)
                setValue('details_ar', null)
                setValue('details_en', null)
                setValue('orders', null)
                setValue('price', null)
                setMessageAlert('تم اضافة الباقة بنجاح')
                setOpenAlert(true)
            }


        } catch (error) {
            if (error.response) {
                setLoadingApi(false)
                setOpenAlertError(true)
                setMessageAlertError(error.response.data.message)
            }
        }
    }

    useEffect(() => {
        getDataSubscrib()
    }, [getDataSubscrib])

    return (
        <>

            {/* Alert Meesage */}
            <Snackbar open={openAlert} autoHideDuration={6000} onClose={handleClose}>
                <Alert severity="success">{messageAlert}</Alert>
            </Snackbar>

            <Snackbar open={openAlertError} autoHideDuration={6000} onClose={handleCloseAlertError}>
                <Alert onClose={handleCloseAlertError} severity="warning" sx={{ width: '100%' }}>
                    {messageAlertError}
                </Alert>
            </Snackbar>

            {/* Modal PopUp Confirm Delete */}
            <Modal open={openModalConfirmDelete} onClose={() => setOpenModalConfirmDelete(false)}>
                <ModalDialog
                    aria-labelledby="nested-modal-title"
                    aria-describedby="nested-modal-description"
                    sx={(theme) => ({
                        [theme.breakpoints.only('xs')]: {
                            top: 'unset',
                            bottom: 0,
                            left: 0,
                            right: 0,
                            borderRadius: 0,
                            transform: 'none',
                            maxWidth: 'unset',
                        },
                        direction: 'rtl'
                    })}
                >
                    <Typography id="nested-modal-title" level="h2">
                        هل انت متاكد من حذف الاشتراك ؟
                    </Typography>
                    <Typography id="nested-modal-description" textColor="text.tertiary">
                        لا يمكن التراجع عن هذا الإجراء. سيؤدي هذا إلى حذف الاشتراك بشكل دائم وإزالة بياناتك من خوادمنا.
                    </Typography>
                    <Box
                        sx={{
                            mt: 1,
                            display: 'flex',
                            gap: 1,
                            flexDirection: { xs: 'column', sm: 'row-reverse' },
                        }}
                    >
                        <Button loading={loadingApi} variant="solid" color="primary" onClick={() => removeٍSubscrib()}>
                            تأكيد
                        </Button>
                        <Button
                            variant="outlined"
                            color="neutral"
                            onClick={() => setOpenModalConfirmDelete(false)}
                        >
                            الغاء
                        </Button>
                    </Box>
                </ModalDialog>
            </Modal>



            {/* Modal Create */}
            <Modal open={open} onClose={() => setOpen(false)}>
                <ModalDialog sx={{ overflowY: 'scroll', direction: 'rtl' }}>
                    <DialogTitle sx={{ fontSize: '20px', color: '#434448', fontWeight: 'bold', marginBottom: '30px' }}>{actionType == 'edit' ? 'تعديل الباقة' : 'اضافة باقة جديد'}</DialogTitle>
                    <form onSubmit={handleSubmit(submitSubscrib)}>
                        <Stack spacing={2} sx={{ width: '500px', height: 'auto', overflowY: 'scroll' }}>
                            <FormControl>
                                <FormLabel sx={{ fontSize: '16px', color: '#434448' }}>اسم الباقة</FormLabel>
                                <Input
                                    placeholder='اسم الباقة.....'
                                    sx={{ height: '60px', borderRadius: '30px' }}
                                    {...register('title_ar')}
                                />
                                {errors.title_ar &&
                                    <Typography
                                        color="danger"
                                        level="body-xs"
                                        variant="plain"
                                    >{errors.title_ar?.message}</Typography>
                                }
                            </FormControl>

                            <FormControl sx={{ direction: 'ltr' }}>
                                <FormLabel sx={{ fontSize: '16px', color: '#434448' }}>Package name</FormLabel>
                                <Input
                                    placeholder='Package name.....'
                                    sx={{ height: '60px', borderRadius: '30px' }}
                                    {...register('title_en')}
                                />
                                {errors.title_en &&
                                    <Typography
                                        color="danger"
                                        level="body-xs"
                                        variant="plain"
                                    >{errors.title_en?.message}</Typography>
                                }
                            </FormControl>

                            <FormControl>
                                <FormLabel sx={{ fontSize: '16px', color: '#434448' }}>تفاصيل الباقة</FormLabel>
                                <Textarea
                                    placeholder="ادخل تفاصيل الباقة هنا....."
                                    minRows={3}
                                    sx={{
                                        '--Textarea-focusedInset': 'var(--any, )',
                                        '--Textarea-focusedThickness': '0.25rem',
                                        '--Textarea-focusedHighlight': 'rgba(13,110,253,.25)',
                                        '&::before': {
                                            transition: 'box-shadow .15s ease-in-out',
                                        },
                                        '&:focus-within': {
                                            borderColor: '#86b7fe',
                                        },
                                        borderRadius: '30px'
                                    }}
                                    {...register('details_ar')}
                                />
                                {errors.details_ar &&
                                    <Typography
                                        color="danger"
                                        level="body-xs"
                                        variant="plain"
                                    >{errors.details_ar?.message}</Typography>
                                }
                            </FormControl>

                            <FormControl sx={{direction:'ltr'}}>
                                <FormLabel sx={{ fontSize: '16px', color: '#434448' }}>Package Details</FormLabel>
                                <Textarea
                                    placeholder="offer details ....."
                                    minRows={3}
                                    sx={{
                                        '--Textarea-focusedInset': 'var(--any, )',
                                        '--Textarea-focusedThickness': '0.25rem',
                                        '--Textarea-focusedHighlight': 'rgba(13,110,253,.25)',
                                        '&::before': {
                                            transition: 'box-shadow .15s ease-in-out',
                                        },
                                        '&:focus-within': {
                                            borderColor: '#86b7fe',
                                        },
                                        borderRadius: '30px',
                                    }}
                                    {...register('details_en')}
                                />
                                {errors.details_en &&
                                    <Typography
                                        color="danger"
                                        level="body-xs"
                                        variant="plain"
                                    >{errors.details_en?.message}</Typography>
                                }
                            </FormControl>

                            <FormControl>
                                <FormLabel sx={{ fontSize: '16px', color: '#434448' }}>سعر الباقة</FormLabel>
                                <Input
                                    type='number'
                                    placeholder='$ سعر الباقة بالريال السعودي'
                                    sx={{ height: '60px', borderRadius: '30px' }}
                                    {...register('price')}
                                />
                                {errors.price &&
                                    <Typography
                                        color="danger"
                                        level="body-xs"
                                        variant="plain"
                                    >{errors.price?.message}</Typography>
                                }
                            </FormControl>

                            <FormControl>
                                <FormLabel sx={{ fontSize: '16px', color: '#434448' }}>عدد السيارات التي تشمل الباقة</FormLabel>
                                <Input
                                    type='number'
                                    placeholder='00.00'
                                    sx={{ height: '60px', borderRadius: '30px' }}
                                    {...register('orders')}
                                />
                                {errors.orders &&
                                    <Typography
                                        color="danger"
                                        level="body-xs"
                                        variant="plain"
                                    >{errors.orders?.message}</Typography>
                                }
                            </FormControl>


                            <Box sx={{ display: 'flex', width: '100%', justifyContent: 'flex-end', paddingTop: '40px' }}>
                                <Button loading={loadingApi} type="submit" sx={{ borderRadius: '15px', backgroundColor: '#3E64F4', height: '60px', width: '170px', marginLeft: '20px' }}>{actionType == 'edit' ? 'تعديل الباقة' : 'اضافة الباقة'}</Button>
                                <Button type="button" onClick={() => setOpen(false)} sx={{ borderRadius: '15px', backgroundColor: '#757778', height: '60px', width: '170px' }}>الغاء</Button>
                            </Box>
                        </Stack>
                    </form>
                </ModalDialog>
            </Modal>

            <Box
                sx={{
                    width: '100%',
                    maxWidth: '100%',
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
                    gap: 2,
                    // justifyContent: 'stretch',
                    alignItems: 'stretch'
                }}
            >
                {subscrib.map((subscribItem) => {
                    return (
                        <Card variant="soft" sx={{ backgroundColor: '#DEE3F5', position: 'relative' }}>
                            <Box component="section" sx={{ width: '16px', height: '16px' }}>
                                <Dropdown>
                                    <MenuButton
                                        slots={{ root: IconButton }}
                                        slotProps={{ root: { variant: 'plan', color: 'plan' } }}
                                        sx={{ backgroundColor: '#3E64F4', borderRadius: '50%', color: '#FFF', scale: '0.7', position: 'absolute', left: '10px', top: '10px' }}
                                    >
                                        <MoreVert />
                                    </MenuButton>
                                    <Menu placement="bottom-end">
                                        {/* <MenuItem sx={{ color: '#434448' }}>
                                            تعطيل/تشغيل
                                            <ListItemDecorator>
                                                <Switch
                                                    variant={checked ? 'solid' : 'outlined'}
                                                    checked={checked}
                                                    onChange={(event) => setChecked(event.target.checked)}
                                                    sx={(theme) => ({
                                                        display: 'inherit',
                                                        '--Switch-trackWidth': '40px',
                                                        '--Switch-trackHeight': '20px',
                                                        '--Switch-thumbSize': '12px',
                                                        '--Switch-thumbBackground': 'rgb(96, 94, 92)',
                                                        '--Switch-trackBorderColor': 'rgb(96, 94, 92)',
                                                        '--Switch-trackBackground': theme.vars.palette.background.body,
                                                        '&:hover': {
                                                            '--Switch-trackBorderColor': 'rgb(50, 49, 48)',
                                                            '--Switch-trackBackground': theme.vars.palette.background.body,
                                                        },
                                                        [`&.${switchClasses.checked}`]: {
                                                            '--Switch-trackBackground': '#0078D4',
                                                            '&:hover': {
                                                                '--Switch-trackBackground': '#106EBE',
                                                            },
                                                        },
                                                        [`&.${switchClasses.disabled}`]: {
                                                            '--Switch-thumbColor': '#C8C6C4',
                                                            '--Switch-trackBorderColor': '#C8C6C4',
                                                        },
                                                        [`&.${switchClasses.disabled}.${switchClasses.checked}`]: {
                                                            '--Switch-trackBackground': '#C8C6C4',
                                                            '--Switch-thumbColor': '#F3F2F1',
                                                        },
                                                        [theme.getColorSchemeSelector('dark')]: {
                                                            '--Switch-trackBorderColor': 'rgb(161, 159, 157)',
                                                            '--Switch-trackBackground': 'rgb(27, 26, 25)',
                                                            '--Switch-thumbBackground': 'rgb(161, 159, 157)',
                                                            '&:hover': {
                                                                '--Switch-trackBorderColor': '#fff',
                                                                '--Switch-thumbBackground': '#fff',
                                                            },
                                                            [`&.${switchClasses.checked}`]: {
                                                                '--Switch-trackBackground': 'rgb(40, 153, 245)',
                                                                '--Switch-thumbBackground': 'rgb(27, 26, 25)',
                                                                '&:hover': {
                                                                    '--Switch-trackBackground': 'rgb(108, 184, 246)',
                                                                },
                                                            },
                                                        },
                                                    })}
                                                />
                                                {' '}</ListItemDecorator>
                                        </MenuItem> */}
                                        <MenuItem sx={{ color: '#434448' }} onClick={() => {openEdit(subscribItem.id)}}>
                                            <ListItemDecorator>
                                                <img src={EditIcon} alt='icon' />
                                            </ListItemDecorator>{' '}
                                            تعديل
                                        </MenuItem>
                                        <MenuItem sx={{ color: '#434448' }} onClick={() => confirmDelete(subscribItem.id)}>
                                            <ListItemDecorator sx={{ color: 'inherit' }}>
                                                <img src={TrashIcon} alt='icon' />
                                            </ListItemDecorator>{' '}
                                            حذف
                                        </MenuItem>
                                    </Menu>
                                </Dropdown>
                            </Box>
                            <CardContent>
                                <Typography level="p" sx={{ fontSize: '14px', color: '#515151' }}>{subscribItem.title}</Typography>
                                <Typography level="h3" sx={{ fontSize: '16px', color: '#515151' }}>{subscribItem.price + ' ريال سعودي'} </Typography>
                                <Typography level="p" sx={{ fontSize: '14px', color: '#7F7F89' }}>{subscribItem.details}</Typography>
                            </CardContent>
                        </Card>
                    )
                })}

                <Card variant="soft" sx={{ backgroundColor: '#FFF', cursor: 'pointer' }}>
                    <Box onClick={openCreateModel} sx={{ paddingTop: '9%' }}>
                        <CardContent sx={{ textAlign: 'center' }}>
                            <img className='plusIconCreateUser' src={IconPlus} alt='add icon' />
                            <Typography level="h3" sx={{ fontSize: '14px', color: '#3E64F4' }}>اضافة باقة جديد</Typography>
                        </CardContent>
                    </Box>
                </Card>
            </Box>
        </>

    );
}